module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "smy__box"
  }, [_c('div', {
    staticClass: "smy__first-menu-box"
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _vm._l((_vm.menuList), function(item) {
    return [(item.hidden == false) ? _c('div', {
      key: item.name,
      staticClass: "first-menu",
      on: {
        "click": function($event) {
          return _vm.changeMain(item.name)
        }
      }
    }, [(item.icon.indexOf('iconfont') !== -1) ? _c('Icon', {
      staticClass: "menu-icon",
      attrs: {
        "custom": item.icon
      }
    }) : _c('Icon', {
      staticClass: "menu-icon",
      attrs: {
        "type": item.icon
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "menu-name"
    }, [_vm._v(_vm._s(item.title))])], 1) : _vm._e()]
  }), _vm._v(" "), _c('div', {
    staticClass: "first-menu",
    on: {
      "click": function($event) {
        return _vm.changeMain('login')
      }
    }
  }, [_c('Icon', {
    staticClass: "menu-icon",
    attrs: {
      "type": "md-log-out"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-name"
  }, [_vm._v("退出")])], 1)], 2), _vm._v(" "), (!_vm.hideMenuText) ? _c('div', {
    staticClass: "smy__second-menu",
    staticStyle: {
      "z-index": "99"
    }
  }, [_c('div', {
    staticClass: "logo-text"
  }, [_vm._v(_vm._s(_vm.$config.title))]), _vm._v(" "), _c('div', {
    staticClass: "smy__second-menu-m"
  }, [_c('Menu', {
    ref: "menu",
    staticClass: "s-menu",
    staticStyle: {
      "font-size": "13px"
    },
    attrs: {
      "theme": "light",
      "collapsible": "false",
      "active-name": _vm.activename,
      "width": "auto",
      "open-names": _vm.openname
    },
    on: {
      "on-select": _vm.currentPageTab
    }
  }, [_c('MenuItem', {
    staticClass: "s-s-menu",
    attrs: {
      "name": "home"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-home",
      "size": _vm.iconSize
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "layout-text"
  }, [_vm._v("首页")])], 1), _vm._v(" "), _c('MenuItem', {
    staticClass: "s-s-menu",
    attrs: {
      "name": "navigator"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-navigate",
      "size": _vm.iconSize
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "layout-text"
  }, [_vm._v("导航")])], 1), _vm._v(" "), _vm._l((_vm.menuList), function(item) {
    return [_vm._l((item.children), function(child) {
      return [(child.hidden == false && child.children && child.children.length == 0 && item.name == _vm.name) ? [_c('MenuItem', {
        key: child.name,
        staticStyle: {
          "margin-left": "2%"
        },
        attrs: {
          "name": child.name
        }
      }, [_c('span', {
        key: child.name + 1,
        staticClass: "layout-text",
        staticStyle: {
          "font-size": "13px"
        }
      }, [_vm._v(_vm._s(child.title))])])] : _vm._e(), _vm._v(" "), (child.hidden == false && child.children && child.children.length >= 1 && child.name !== 'main' && item.name == _vm.name) ? _c('Submenu', {
        key: child.path,
        attrs: {
          "name": child.name
        }
      }, [_c('template', {
        slot: "title"
      }, [_c('span', {
        staticClass: "layout-text"
      }, [_vm._v(_vm._s(child.title))])]), _vm._v(" "), _vm._l((child.children), function(child) {
        return [(child.hidden == false && item.name == _vm.name) ? [_c('MenuItem', {
          key: child.name,
          staticStyle: {
            "margin-left": "2%",
            "display": "block"
          },
          attrs: {
            "name": child.name
          }
        }, [_c('span', {
          key: child.name + 1,
          staticClass: "layout-text",
          staticStyle: {
            "font-size": "13px"
          }
        }, [_vm._v(_vm._s(child.title))])])] : _vm._e()]
      })], 2) : _vm._e()]
    })]
  })], 2)], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc84f800","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/menu.vue
// module id = 470
// module chunks = 99